/**
 * Widget Category Section - Collapsible section showing widgets by category
 */

import React, { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { WidgetDefinition } from '../widget-registry'
import DraggableStoreWidget from './DraggableStoreWidget'

interface WidgetCategorySectionProps {
    title: string
    titleKey?: string
    widgets: WidgetDefinition[]
    defaultOpen?: boolean
    onAddWidget?: (widgetId: string) => void
}

const WidgetCategorySection: React.FC<WidgetCategorySectionProps> = ({
    title,
    titleKey,
    widgets,
    defaultOpen = true,
    onAddWidget,
}) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(defaultOpen)

    if (widgets.length === 0) return null

    return (
        <div className="space-y-2">
            {/* Section header */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center gap-2 px-2 py-1.5 text-left
                    hover:bg-gray-50 rounded-lg transition-colors"
            >
                {isOpen ? (
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                ) : (
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                )}
                <span className="text-sm font-semibold text-gray-700">
                    {titleKey ? t(titleKey) : title}
                </span>
                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
                    {widgets.length}
                </span>
            </button>

            {/* Widgets list */}
            {isOpen && (
                <div className="space-y-2 pl-2">
                    {widgets.map((widget) => (
                        <DraggableStoreWidget
                            key={widget.id}
                            widget={widget}
                            onAdd={onAddWidget}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}

export default WidgetCategorySection
